import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        let queryUrl = url.substring(url.indexOf("?")+1, url.length);
        let urlParams = new URLSearchParams(queryUrl);
        let source = urlParams.get("source");
        let medium = urlParams.get("utm_medium");
        let campaign = urlParams.get("utm_campaign");
        let quickbuyid = urlParams.get("quickbuyId");
        let auth = urlParams.get("auth")
       
        if(source!= null || medium != null || campaign != null || auth != null || quickbuyid!=null ){

            const uppercaseUrl = super.parse(url);
            
            return uppercaseUrl;
        }
        const lowercaseUrl = super.parse(url.toLowerCase()); 
        
        return lowercaseUrl
    }
}